export const getMetaElementByName = (name: string): HTMLMetaElement | null =>
  document.head.querySelector(`meta[name=${name}]`);

export function getMetaAttributes<T>(
  metaName: string,
  attributes: Array<string | { name: string; parse?: boolean }>
): T | [] {
  const metaElement = getMetaElementByName(metaName);

  if (!metaElement) {
    return [];
  }

  return attributes.map((attribute) => {
    const { name, parse = false } =
      typeof attribute === 'string' ? { name: attribute } : attribute;
    const attributeData = metaElement.getAttribute(name) ?? '';

    return parse ? JSON.parse(attributeData || '{}') : attributeData;
  }) as any as T;
}
